export enum ParticipantRole {
  CANDIDATE = 'candidate',
  HR = 'hr',
  TECH_SPECIALIST = 'techSpecialist',
  PARTICIPANT = 'participant',
}

export interface CalendarEventParticipant {
  email: string;
  fullName: string;
  role: ParticipantRole;
}

export interface CalendarEventPayloadBase {
  title: string;
  description?: string;
  candidateEmail: string;
  startTime: string;
  endTime: string;
  timeZone: string;
  participants: Array<{ email: string }>;
  attachmentUuid?: string[];
}

export interface CalendarEventCreatePayload extends CalendarEventPayloadBase {
  personId: number;
  personRecordId: number;
}

export type CalendarEventUpdatePayload = CalendarEventPayloadBase;

export interface CalendarInterview {
  id: number;
  personRecordId: number;
  googleEventId: string;
  title: string;
  description?: string;
  meetLink?: string;
  startTime: string;
  endTime: string;
}

export interface GoogleCalendarEventDateTime {
  dateTime?: string;
  date?: string;
  timeZone?: string;
}

export interface GoogleCalendarEventRaw {
  summary?: string;
  description?: string;
  start_time?: string | GoogleCalendarEventDateTime;
  end_time?: string | GoogleCalendarEventDateTime;
  meet_link?: string;
  participants?: Array<{ email?: string; responseStatus?: string }>;
}

export interface CalendarEventFormData {
  title: string;
  description: string;
  startTime: string;
  endTime: string;
  timeZone?: string;
  meetLink?: string;
  participants: Array<{ email: string }>;
}
